import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class FortePaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  constructor(options?: Partial<FortePaymentProcessorAccountConfiguration>) {
    super(options);
  }
}
